<template lang="pug">
div
  v-breadcrumbs.py-4(:items="breadcrumbItems")
    template(v-slot:item="{ item }")
      a.c1.link-xs.primary400--text(v-if="!item.disabled" :href="item.href") {{ item.text }}
      .c1.primary400--text(v-else) {{ item.text }}
  v-divider.mb-2
  v-container(style="max-width:960px")
    v-row
      v-col
        h5 {{ $t('choose_customers') }}
        .mt-2.p1 {{ $t('selected_customers_will_added_to_segment') }}
    v-row.ma-16(v-if="isLoading" align="center" justify="center")
      v-progress-circular.ma-auto(width=2 size=50 color="primary400" indeterminate)
    patient(v-else :isSelectionMode="true" @onContinue="onContinue" @onSelectedCustomers="updateSelectedCustomers" :confirmText="$t('save')" :loading="isSaving" :previousCustomers="previousCustomers")
      template(v-slot:actions)
        .d-flex.mt-4
          v-btn.button-Aa-medium.px-4(@click="backToName" color="neutral500" text height=40) {{ $t('back') }}
          v-spacer
          v-btn.button-Aa-medium.px-4(@click="save" color="info" :disabled="!selectedCustomers.length" :loading="isSaving" depressed height=40) {{ $t('save') }}
</template>

<script>
import Patient from './Patients.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { Patient },
  props: ['id'],
  data: () => ({
    segment: null,
    isSaving: false,
    isLoading: true,
    selectedCustomers: [],
    previousCustomers: [],
    breadcrumbItems: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    })
  },
  created() {
    this.fetchSegment()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSegment() {
      this.isLoading = true
      this.$axios.get(`/connect/${this.company.slug}/groups/${this.id}`)
      .then(resp => {
        this.segment = resp.data
        this.previousCustomers = resp.data.customer
        this.updateBreadcrumbs()        
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    onContinue(list) {
      this.selectedCustomers = list
      this.save()
    },
    save() {
      const selectedIds = this.selectedCustomers.map(item => item.id)
      const prevIds = this.segment.customer || []
      const ids = [...new Set([...selectedIds, ...prevIds])]
      this.isSaving = true
      this.$axios.patch(`/connect/${this.company.slug}/groups/${this.id}/?expand=customer`, { customer: ids })
      .then(() => {
        this.showMessage(['success', this.$t('success_message.segment_update_successful')])
        this.$router.push(`/admin/clinic/segments/${this.id}`)
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.segment_update_unsuccessful')])
      })
      .finally(() => {
        this.isSaving = false
      })
    },
    updateBreadcrumbs() {
      this.breadcrumbItems = [
        {
          text: this.segment.title,
          disabled: false,
          href: `/admin/clinic/segments/${this.segment.id}`
        },
        {
          text: 'Add customer from customer’s list',
          disabled: true
        }
      ]
    },
    updateSelectedCustomers(list) {
      this.selectedCustomers = list
    }
  }
}
</script>
